import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { getEmployeeById } from "../../../apis/employees";
import { formatDate } from "../../../environment";

const ViewNational = () => {
  const [formlist, setFormList] = useState(null);
  const [parsedAddress, setParsedAddress] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const rawData = queryParams.get("EmployeeData");

  useEffect(() => {
    const fetchNationalDetails = async () => {
      try {
        const response = await getEmployeeById(rawData);
        const parsedAdd = JSON.parse(response?.data?.address);
        setFormList(response?.data || {});
        setParsedAddress(parsedAdd);
      } catch (error) {
        console.error("Failed to fetch national details", error);
      }
    };
    fetchNationalDetails();
  }, [rawData]);

  const fields = [
    { label: "Full Name", value: formlist?.full_name, icon: "fa-user" },
    { label: "Email", value: formlist?.email, icon: "fa-envelope" },
    { label: "Phone Number", value: formlist?.phone_number, icon: "fa-phone" },
    {
      label: "Company Name",
      value:
        formlist?.retailer?.company_name ||
        formlist?.national?.company_name ||
        formlist?.super_distributer?.company_name ||
        formlist?.distributer?.company_name ||
        formlist?.financer?.company_name,
      icon: "fa-building",
    },
    {
      label: "Address",
      value: parsedAddress?.addressLine,
      icon: "fa-map-marker-alt",
    },
    { label: "City", value: parsedAddress?.city, icon: "fa-map-marker-alt" },
    { label: "State", value: parsedAddress?.states, icon: "fa-map-marker-alt" },
    {
      label: "Country",
      value: parsedAddress?.country,
      icon: "fa-map-marker-alt",
    },
    {
      label: "Pincode",
      value: parsedAddress?.pincode,
      icon: "fa-map-marker-alt",
    },
    { label: "Username", value: formlist?.user?.username, icon: "fa-user" },
    { label: "User Type", value: formlist?.user?.type, icon: "fa-user" },
    // { label: "Geo Location", value: formlist?.geo_location },
    // { label: "Profile Picture", value: <img src={formlist?.profile_pic} alt="Profile" style={{ width: '100px', height: '100px', borderRadius: '50%', display: 'block', marginBottom: '10px' }} /> },
    {
      label: "Created At",
      value: formatDate(formlist?.createdAt),
      icon: "fa-calendar",
    },
    // { label: "Updated At", value: formlist?.updatedAt },
    // { label: "National ID", value: formlist?.national_id },
    // { label: "Distributor ID", value: formlist?.distributor_id },
    // { label: "Financer ID", value: formlist?.financer_id },
    // { label: "Retailer ID", value: formlist?.retailer_id },
    // { label: "Employee Model Type", value: formlist?.employee_model_type },
    {
      label: "Parent Name",
      value:
        formlist?.retailer?.company_name ||
        formlist?.national?.company_name ||
        formlist?.super_distributer?.company_name ||
        formlist?.distributer?.company_name ||
        formlist?.financer?.company_name,
      icon: "fa-user",
    },
    { label: "Owner Name", value: "Retailer", icon: "fa-user" },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        {formlist && (
          <div className="card shadow-sm rounded-3 border-0">
            <div className="card-header bg-primary text-white py-3">
              <h2 className="mb-0 text-center text-white">
                {formlist?.retailer?.company_name ||
                  formlist?.national?.company_name ||
                  formlist?.super_distributer?.company_name ||
                  formlist?.distributer?.company_name ||
                  formlist?.financer?.company_name}
              </h2>
            </div>
            <div className="card-body p-4">
              <div className="row g-4">
                {fields.map((field, index) => (
                  <div key={index} className="col-md-6">
                    <p className="info">
                      <span className="info-label">
                        <i className={`fas ${field.icon}`}></i> {field.label} :
                      </span>
                      <span className="info-value">
                        {" "}
                        {field.value || "N/A"}
                      </span>
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewNational;
